import { Box, Button, FormControlLabel, Switch } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import RenderHTML from '../../components/preview/RenderHTML';
import StyledTextContainer from '../../components/preview/StyledTextContainer';
import { useConfig } from '../../api/api';

const AcceptTerms = ({ onAccept, onwCompanyData, recipientType }) => {
  const { t } = useTranslation();

  const isContact = recipientType === 'contact';
  const totalSteps = isContact ? 3 : 2;

  const [activeStep, setActiveStep] = useState(0);
  const [status, setStatus] = useState(
    isContact ? [false, false, false] : [false, false],
  );

  function handleChange(e) {
    var newStatus = [...status];
    newStatus[activeStep] = e.target.checked;
    setStatus(newStatus);
  }

  function handleNext() {
    const nextStep = activeStep + 1;
    setActiveStep(nextStep);
    if (nextStep >= totalSteps) onAccept();
  }

  return (
    <Box className="h-full flex flex-col overflow-y-auto">
      {activeStep === 0 && (
        <TermsOfService
          onChange={handleChange}
          status={status[activeStep]}
          data={onwCompanyData.termsAndConditionsDigitalSignature}
        />
      )}
      {activeStep === 1 && (
        <Privacy
          onChange={handleChange}
          status={status[activeStep]}
          data={onwCompanyData.privacyPolicy}
        />
      )}
      {activeStep === 2 && isContact && (
        <WithdrawalDeclaration
          onChange={handleChange}
          status={status[activeStep]}
          data={onwCompanyData.withdrawalDeclaration}
        />
      )}
      <Box className="flex justify-center pt-2">
        <Button
          variant="contained"
          color="success"
          disabled={!status[activeStep]}
          onClick={handleNext}
        >
          {t('Next')}
        </Button>
      </Box>
    </Box>
  );
};

const TermsOfService = ({ onChange, status, data }) => {
  const { t } = useTranslation();
  return (
    <Box className="flex flex-col gap-2 w-full">
      <StyledTextContainer
        fullWidth
        backgroundColor={'transparent'}
        className="w-full"
      >
        <RenderHTML HTML={data} />
      </StyledTextContainer>
      <Box className="px-2">
        <FormControlLabel
          control={<Switch onChange={onChange} value={status} />}
          label={t(
            'I have read, understood and accept the general terms of service',
          )}
        />
      </Box>
    </Box>
  );
};

const Privacy = ({ onChange, status, data }) => {
  const { t } = useTranslation();
  return (
    <Box className="flex flex-col gap-2">
      <StyledTextContainer fullWidth backgroundColor={'transparent'}>
        <RenderHTML HTML={data} />
      </StyledTextContainer>
      <Box className="px-2">
        <FormControlLabel
          control={<Switch onChange={onChange} value={status} />}
          label={t('I have read, understood and accept the privacy statement')}
        />
      </Box>
    </Box>
  );
};

const WithdrawalDeclaration = ({ onChange, data }) => {
  const { t } = useTranslation();

  const config = useConfig();

  const { withdrawalDeclaration } = config || {};
  const { checks } = withdrawalDeclaration || {};

  const [mainChecked, setMainChecked] = useState(false);
  const [checkStates, setCheckStates] = useState(
    checks ? checks.map(() => false) : [],
  );

  function updateStatus(newMain, newCheckStates) {
    const allRequiredMet = checks
      ? checks.every((check, i) => !check.isRequired || newCheckStates[i])
      : true;
    const allDone = newMain && allRequiredMet;
    onChange({ target: { checked: allDone } });
  }

  function handleMainChange(e) {
    const checked = e.target.checked;
    setMainChecked(checked);
    updateStatus(checked, checkStates);
  }

  function handleCheckChange(index) {
    return (e) => {
      const newStates = [...checkStates];
      newStates[index] = e.target.checked;
      setCheckStates(newStates);
      updateStatus(mainChecked, newStates);
    };
  }

  return (
    <Box className="flex flex-col gap-2">
      <StyledTextContainer fullWidth backgroundColor={'transparent'}>
        <RenderHTML HTML={data} />
      </StyledTextContainer>
      <Box className="px-2">
        <FormControlLabel
          sx={{ alignItems: 'flex-start' }}
          control={
            <Switch onChange={handleMainChange} checked={mainChecked} />
          }
          label={t(
            'I have read, understood and accept the withdrawal declaration',
          )}
        />
        {checks &&
          checks.map((check, index) => (
            <FormControlLabel
              key={index}
              sx={{ alignItems: 'flex-start' }}
              control={
                <Switch
                  onChange={handleCheckChange(index)}
                  checked={checkStates[index]}
                />
              }
              label={t(check.label)}
            />
          ))}
      </Box>
    </Box>
  );
};

export default AcceptTerms;
